// iter_302 · 書類読み取り学習の使い方（日本語 / English）
import { useState } from 'react';
import { ArrowLeft } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import { Panel } from './shared';

const QUICK_JA = [
  '例として使う書類を選ぶ',
  '読み取り結果を確認する',
  '間違いを修正する',
  '学習候補を承認する',
  '効果を確認して有効にする',
];
const QUICK_EN = [
  'Pick a document to use as an example',
  'Check the reading result',
  'Correct what is wrong',
  'Approve the learning candidate',
  'Validate the effect, then activate',
];

const SECTIONS_JA = [
  { id: 'teaching', title: '人が教えるしくみ',
    body: ['実際の書類を選び、場所を指定し、その場所が何かを説明します。',
      'システムが理解した内容を言い直すので、正しければ保存、違えば直します。',
      '保存はまず「この書類の修正」だけ。今後の読み取りに使う候補は任意です。'] },
  { id: 'region', title: '領域の指定のしかた',
    body: ['「学習する」→ 読み取り結果の下の「領域を指定して意味を教える」で行います。',
      'プレビュー上でドラッグして範囲を選び、場所の種類（タイトル欄・押印欄など）を選びます。',
      '印字された文字（DESIGNED など）と、対応する項目（設計者など）を指定できます。',
      '座標は0〜1の相対値で保存され、元のファイルは変更しません。'] },
  { id: 'explain', title: '領域の説明のしかた',
    body: ['「この場所の説明」に、なぜそう読むのかを書きます（例: 設計欄の丸印です）。',
      '説明は学習候補に添付され、承認する人が判断の材料に使います。'] },
  { id: 'stamp_teach', title: '押印の教え方',
    body: ['押印欄を領域として指定し、個人名か部署名かを選びます。',
      '部署印（技術部など）は個人として登録されません。',
      '押印だけで個人を確定することはありません。'] },
  { id: 'negative', title: '誤りやすい例（否定例）の教え方',
    body: ['領域の「例の種類」で「誤りやすい例」を選びます。',
      '例: この日付は氏名ではない / この社印は承認者ではない / この押印は検図欄のもの。',
      '影響が大きい学習候補（氏名の読み替えなど）は、否定例が無いと「例が不足」で止まります。'] },
  { id: 'preview', title: 'システムの理解の確認',
    body: ['保存の前に「あなたの説明を次のように理解しました」を表示します。',
      '対象・場所・読み取った文字・項目・種類・この書類への反映・今後への反映を確認できます。',
      '「この書類だけ修正」を選べば、今後の読み取りには影響しません。'] },
  { id: 'conflict', title: '矛盾の解消',
    body: ['同じ条件で違う結果になる候補、範囲が重なる候補は承認前に指摘されます。',
      '現在のルールを維持・提案を採用・適用範囲を分ける・修正して承認・却下から選びます。'] },
  { id: 'few_examples', title: '例が少ないとき',
    body: ['検証用の書類が足りない場合は「検証用の書類が不足しています」と表示され、',
      '影響の大きい学習内容は有効化できません。実際の書類を追加してください。'] },
  { id: 'what', title: 'この画面でできること',
    body: ['実際の書類を例として登録し、読み取り結果を確認できます。',
      '人が直した内容から、今後の読み取りに使えるルールの候補を作れます。',
      '管理者が承認し、検証に通った内容だけが読み取りに使われます。'] },
  { id: 'not', title: 'この画面がしないこと',
    body: ['AIモデルの学習（重みの変更）はしません。',
      '1件の確認だけで全体の読み取り方法を変えることはしません。',
      '確認済みの書類の値を勝手に書き換えません。',
      '元のファイルを変更しません。',
      '押印の形だけで個人を確定しません。',
      '承認のない機密書類を学習に使いません。',
      '検証前のルールを有効にしません。',
      '社外の学習サービスに書類を送りません。'] },
  { id: 'add', title: '学習用の書類を追加する',
    body: ['「学習する」→「書類を選ぶ」で、既存の書類・新しいファイル・NASのいずれかから選びます。',
      '追加しただけでは学習内容になりません（状態は「未確認」です）。',
      '参照元の版と内容ハッシュを記録し、元の書類が変わると「旧版」として扱います。'] },
  { id: 'diff', title: '書類の修正と、再利用する学習の違い',
    body: ['書類の修正: その書類の値だけを直します。すぐ反映されます。',
      '学習候補: 今後ほかの書類を読むときの候補になります。承認と検証が必要です。',
      '「学習する」の最後の画面で、この2つを分けて確認できます。'] },
  { id: 'approve', title: '承認のしくみ',
    body: ['「承認する」には7つの表示があります（確認が必要・追加例が必要・不一致あり・承認済み・却下・後で確認・最近更新）。',
      'カードには、提案内容・分類・元の書類の数・支えとなる修正の数・正しい例と誤りやすい例の数・',
      '対象の書類の種類・推奨する適用範囲・影響の大きさ・不一致の状態・提出者・最終更新・次にすることが出ます。',
      '「内容を確認」を押すと、決まった順番（提案内容 → 元になった修正 → 正しい例 → 誤って適用してはいけない例 →',
      '適用範囲 → 影響の大きさ → 現在の内容との不一致 → 承認後に起きること → 技術情報）で確認できます。',
      '操作は、承認・修正して承認・却下・追加例を求める・後で確認・候補を分割・適用範囲を変更です。',
      '承認しただけでは、今後の読み取りには使用されません。'] },
  { id: 'grouping', title: '似た候補のまとめ方',
    body: ['種類・項目・修正後の内容・個人か部署かの区別・対象の書類の種類・領域・押印の種類・',
      '材質の対象・影響の大きさが完全に一致するときだけ、自動でまとめます。',
      '「小山（設計者）」と「小山（検図者）」、社員と部署、部署と会社は、まとめません。',
      'まとめられた候補は「グループを分ける」または「候補を分割」で個別に確認できます。'] },
  { id: 'scope_ht2', title: '適用範囲の決め方',
    body: ['できるだけ狭い範囲を勧めます（例: 機械図面のタイトル欄の DESIGNED 欄だけ）。',
      '「限定的」「やや広い」「広い」の3段階で表示します。',
      '「広い」範囲は警告が出て、正しい例が2件以上と、範囲を広くする理由が必要です。',
      '実書類で確認していない種類は「実書類で未検証」と表示され、HT-3で有効化できません。'] },
  { id: 'risk_ht2', title: '影響の大きさ',
    body: ['小: 印字ラベルの別名・限定的な項目の位置・材質の読み替え・読み取らない領域。',
      '中: レイアウトの型・責任者欄の対応・部署印の判定・図面種類の手がかり・日付の書式。',
      '大: 氏名の読み替え・押印と個人の対応・責任者の役割の推定・会社と個人の区別・広い範囲の規則。',
      '確認者は影響の大きさを上げられます。システムが「大」と判定したものを下げるには特別な権限と理由が必要です。'] },
  { id: 'conflicts_ht2', title: '不一致の見かた',
    body: ['同じ条件で別の結果・範囲の重なり・広い規則が限定的な規則を覆う・部署や会社を個人にする・',
      '同じ読み替えが複数の氏名に割り当てられる・同じラベルが複数の項目に割り当てられる・',
      '材質の別名の衝突・使えない項目・誤りやすい例との矛盾・元の書類が変わった、を検出します。',
      '安全規則に触れる不一致は、理由を書いても解消できません（却下または修正が必要です）。'] },
  { id: 'model_ht2', title: '現在使用中の読み取り構成',
    body: ['「承認する」と「概要」の折りたたみで、使用中のモデル・モデルの追加設定の有無・',
      '有効な学習内容・最後の検証・以前の内容に戻せるかを確認できます。',
      'モデルの重み・アダプタ・チェックポイントは、この画面から一切変更しません。',
      '出所を確認できない項目は「要確認」と表示します（推測で埋めません）。'] },
  { id: 'validation_ht3', title: '検証セットの使い方',
    body: ['書類の集合を3つに分けます: 学習に使った書類 / 検証用の書類 / 守るべき書類（悪化させない）。',
      '検証用の書類には期待値（正しい読み取り結果）を持たせます。',
      '1つのファイルを、影響の大きい候補の「学習に使った書類」かつ「唯一の検証用の書類」にはできません。',
      '機械図面・電気図面・回路図・配線図・ブロック図・フローチャートは必ず区別して数えます。'] },
  { id: 'activation_ht3', title: '検証と有効化',
    body: ['「効果を確認」で、承認済みの内容から学習内容を作り、検証します。',
      '結果は4つのどれかです: 検証に合格 / 検証で不合格 / データが不足 / 悪化のおそれ。',
      '1つの精度だけを見せず、項目ごとに「これまで → この学習内容」を並べます。',
      '合格したときだけ「有効にする」が押せます（管理者のみ）。',
      '実書類で確認できていない種類は、その種類だけ有効になりません。'] },
  { id: 'rollback_ht3', title: '以前の学習内容に戻す',
    body: ['「効果を確認」の履歴から、いつでも直前の有効な内容に戻せます（管理者のみ）。',
      '戻しても、過去の読み取り結果・確認済みの値・監査・学習候補は消えません。',
      '過去の書類に反映したい場合は、その書類を明示的に読み取り直します。'] },
  { id: 'controlled_ht3', title: '有効にした内容の使われ方',
    body: ['渡すのは手がかりだけです: レイアウト・タイトル欄・押印・項目の対応・材質の別名・例。',
      '氏名を自動で確定しません。権限・エビデンス・材質辞書・書類プロファイルの規則も上書きしません。',
      'モデルの重み・アダプタ・プロンプト・機能の割り当ては変更しません。'] },
  { id: 'influence_ht4', title: 'この読み取りに使われた学習内容',
    body: ['書類の読み取り結果に、使われた学習内容が表示されます。',
      '閲覧者には「何にどう効いたか」の要約が出ます。',
      '管理者には、使った規則・変更前と変更後・場所・範囲外だった規則まで表示されます。',
      '学習は候補を出すだけで、確定はしません。'] },
  { id: 'impact_ht4', title: '学習の適用状況（管理者）',
    body: ['「効果を確認」の「学習の適用状況」で、有効にした学習内容が実際にどう使われたかを確認できます。',
      '規則ごとに、使われているか・何件の書類で使われたか・どんな効果かを説明つきで表示します。',
      'まだ使われていない規則も分かるので、範囲が狭すぎる規則を見直せます。',
      '過去の書類は自動で書き換えません（新しい読み取りと明示的な再読み取りだけに反映されます）。'] },
  { id: 'reread_ht4', title: '読み直すと役立つ書類（管理者）',
    body: ['「効果を確認」の「読み直すと役立つ書類」で、今の学習内容で改善しそうな書類が分かります。',
      '書類ごとに「なぜ役立つか」（例: 「ｺﾔﾏ」の読み替えが使えます）を日本語で示します。',
      '自動では読み直しません。管理者が選んだ書類だけを、一度に20件まで読み直します。',
      '読み直しても、確認済み・修正済みの値は上書きされません（新しい読みは候補として出ます）。',
      '読み取りのしくみ（モデル・プロンプト・機能の割り当て）は変わりません。'] },
  { id: 'ops_ht45', title: '日々の運用（HT-4.5）',
    body: ['社員名簿との照合: 読み取った氏名を社員名簿と照合し、完全一致 → 承認済みの読み替え → 部分一致の順で候補を示します。提案だけで、自動では確定・選択しません。',
      '責任者の一括確認: 書類 →「責任者の一括確認」で、未確認の製図者・設計者・検図者・承認者をまとめて確認できます。書き込みは通常の確認操作と同じです。',
      '読み直しの履歴: だれが・いつ・どの書類を読み直したかを、操作の記録から確認できます。',
      '実書類での確認状況: 種類ごとに「何が足りないか」と、追加できる実書類の候補を表示します。実書類を取り込む → 読み取る → 期待値を入力する → 実書類で確認済みになる、の4ステップで進めます。読み取りの種類が違う書類は登録されません（判定結果をそのまま表示します）。自社で作成しない種類は、理由を記録して「対象外」にできます（対象外でも実書類がないため有効化はされません）。',
      '書類読み取り学習レポート: 毎月自動で保存されます。今月の宿題から、次にやることへ直接移動できます。書き出しは手動です。'] },
  { id: 'validate', title: '検証のしくみ',
    body: ['検証用の図面と、間違いを見つけるための対照例で読み取りを比べます。',
      '責任者の誤一致・部署印を個人名とした誤り・禁止項目の混入が出た学習内容は有効にできません。',
      '検証結果は履歴として残ります。'] },
  { id: 'activate', title: '有効にする',
    body: ['承認 → 検証 → 有効化の順に進みます。承認と有効化は別の操作です。',
      '有効になった学習内容は、次回以降の読み取りで使われます。',
      '過去に読み取った書類は自動では変わりません。必要なときに再読み取りしてください。'] },
  { id: 'rollback', title: '以前の学習内容に戻す',
    body: ['「効果を確認」→「学習履歴」から戻せます。',
      '直前の有効なバージョンが再び有効になります。',
      '過去の読み取り結果と、確認済みの書類の値は変更しません。'] },
  { id: 'stamps', title: '押印と手書きの扱い',
    body: ['押印は、位置・形・文字・周囲の項目名を組み合わせて候補を作ります。',
      '押印だけで個人を確定することはありません。',
      '「技術部」のような部署印は、個人名として登録しません。',
      '「小山」のような候補も、確認するまでは確定情報になりません。',
      '例: 個人印（丸印） / 部署印（角印） / 社印 / 氏名と日付の印 / 手書き氏名 / かすれた押印。'] },
  { id: 'confidential', title: '機密書類の扱い',
    body: ['参照元の権限（ドキュメントの公開範囲）がそのまま適用されます。',
      '権限のない書類は学習用に選べません。',
      '参照元が削除されると、その例は無効になります。',
      '集計や報告に、機密書類の中身は出しません。'] },
  { id: 'trouble', title: '困ったときは',
    body: ['「有効にできません」と出る: 検証で問題が見つかっています。検証結果の理由を確認してください。',
      '例が「旧版」になった: 参照元の書類が更新されています。読み取りをやり直してから確認してください。',
      '候補が出ない: 押印がかすれている、または欄が空です。「判読不能」のまま確認を保留できます。',
      '承認できない: 管理者権限が必要です。'] },
  { id: 'glossary', title: '用語',
    body: ['学習用書類: 読み取りを確認するための例として使う書類。',
      '修正内容: 人が直した内容。',
      '学習候補: 修正内容から作られた、今後の読み取りルールの候補。',
      '承認済みの学習内容: 管理者が承認した候補。',
      '有効な学習内容: 検証に通り、実際に使われている内容。',
      '効果の確認: 検証用の図面で読み取りを比べること。',
      '項目の位置: 図面のどこにその項目があるか。',
      '押印の種類: 丸印・角印・社印などの種類。',
      '人・部署などの種類: 候補が個人か部署か会社かの区別。'] },
];

const SECTIONS_EN = [
  { id: 'teaching', title: 'How human teaching works',
    body: ['Pick a real document, mark the location, and explain what it is.',
      'The system restates its understanding before anything is saved.',
      'The default save is document-only; a reusable candidate is opt-in.'] },
  { id: 'region', title: 'Selecting a region',
    body: ['Teach → below the reading result: drag on the preview to select an area.',
      'Choose the region role, the printed label and the canonical field.',
      'Coordinates are stored 0–1 relative; the original file is never modified.'] },
  { id: 'explain', title: 'Explaining a region',
    body: ['Write why it reads that way; the explanation travels with the proposal.'] },
  { id: 'stamp_teach', title: 'Teaching a stamp',
    body: ['Mark the stamp cell and state whether it is a person or a department.',
      'Department seals never become employees; a stamp alone never confirms a person.'] },
  { id: 'negative', title: 'Providing a negative example',
    body: ['Set a region as “likely to be misread”.',
      'High-risk proposals (person aliases) stay in “needs examples” without one.'] },
  { id: 'preview', title: 'How the system shows its understanding',
    body: ['A restatement dialog lists target, place, text, field, entity type,',
      'the effect on this document and the effect on future documents.'] },
  { id: 'conflict', title: 'How conflicts are resolved',
    body: ['Overlapping or contradicting proposals are surfaced before approval.'] },
  { id: 'few_examples', title: 'When there are too few examples',
    body: ['Validation is blocked and the UI says the validation set is insufficient.'] },
  { id: 'what', title: 'What this page does',
    body: ['Register real documents as examples and review how they were read.',
      'Turn human corrections into candidate rules for future reading.',
      'Only admin-approved and validated content is ever used.'] },
  { id: 'not', title: 'What this page does not do',
    body: ['It does not fine-tune the LLM or change model weights.',
      'One confirmation never becomes a global rule.',
      'It never overwrites confirmed document values.',
      'It never modifies the original file.',
      'It never identifies a person from a stamp alone.',
      'It never uses confidential files without approval.',
      'It never activates a rule before review and validation.'] },
  { id: 'add', title: 'Adding training examples',
    body: ['Teach → Select document: existing document, new file, or an approved NAS folder.',
      'Adding is not approval — the example starts as “unconfirmed”.',
      'The source version and content hash are recorded; changed sources become stale.'] },
  { id: 'diff', title: 'Document correction vs reusable learning',
    body: ['Document correction affects only that document and applies immediately.',
      'A learning candidate may affect future documents, but only after approval and validation.'] },
  { id: 'approve', title: 'How approval works',
    body: ['The inbox has seven views: needs review, needs examples, conflicts, approved, rejected, deferred, recently updated.',
      'Each card shows the proposal, category, source-document count, supporting corrections,',
      'positive and negative example counts, affected profile, recommended scope, risk, conflict state,',
      'who submitted it, when it was updated and the recommended next action.',
      'The detail view always follows the same order: proposal → source corrections → positive examples →',
      'examples it must not apply to → scope → impact → conflicts → what happens after approval → technical info.',
      'Actions: approve, approve with changes, reject, request examples, defer, split, change scope.',
      'Approval alone never changes future reading.'] },
  { id: 'grouping', title: 'How similar proposals are grouped',
    body: ['Grouping happens only when pattern type, field, corrected effect, entity type, profile,',
      'region role, stamp type, material target and risk all match exactly.',
      'Koyama-as-designer and Koyama-as-checker, employee vs department, department vs company are never grouped.',
      'Any member can be split out for separate review.'] },
  { id: 'scope_ht2', title: 'How scope is chosen',
    body: ['The narrowest justified scope is recommended and shown as narrow / wide / broad.',
      'A broad scope shows a stronger warning and needs two positive examples plus a written reason.',
      'Profiles without real-file coverage are labelled “not verified on real documents” and HT-3 will block activation.'] },
  { id: 'risk_ht2', title: 'Impact size',
    body: ['Small: printed-label alias, narrow field position, material OCR alias, excluded region.',
      'Medium: layout template, responsibility cell mapping, department-stamp classification, drawing-type hint, date layout.',
      'Large: person-name alias, stamp-to-person mapping, role inference, company/person distinction, broad rules.',
      'A reviewer may raise the impact; lowering a system-calculated “large” needs advanced permission and a reason.'] },
  { id: 'conflicts_ht2', title: 'Reading the conflicts',
    body: ['Same condition with a different effect, overlapping scope, a broader rule shadowing a narrower one,',
      'department or company treated as a person, one alias mapped to several people, one label mapped to several fields,',
      'material alias collision, forbidden field, contradiction with a negative example, stale source.',
      'Conflicts that touch code-owned safety rules cannot be waived with a note.'] },
  { id: 'model_ht2', title: 'Current reading configuration',
    body: ['A collapsed panel shows the deployed model, whether extra model customization exists,',
      'the active structured-learning version, the last validation state and rollback availability.',
      'Model weights, adapters and checkpoints are never changed from this screen.',
      'Anything whose provenance cannot be verified is labelled “要確認 (needs verification)”.'] },
  { id: 'validation_ht3', title: 'Validation sets',
    body: ['Documents are split into three categories: training, validation and protected regression.',
      'Validation documents carry expected values so the run can be scored.',
      'One file cannot be both the training source and the only validation source for a high-impact proposal.',
      'Mechanical, electrical, circuit, wiring, block diagrams and flowcharts are always counted separately.'] },
  { id: 'activation_ht3', title: 'Validation and activation',
    body: ['In 効果を確認 you build a learning version from approved proposals and validate it.',
      'The outcome is one of four: passed, failed, needs more data, regression risk.',
      'Never a single opaque accuracy number — every metric is shown as before → after.',
      'Only a passed validation can be activated, and only by an admin.',
      'Profiles without real-document coverage are not activated.'] },
  { id: 'rollback_ht3', title: 'Rollback',
    body: ['An admin can return to the previous active version at any time from the history.',
      'Rollback never deletes past readings, confirmed values, audits or proposals.',
      'To apply a change to an old document, re-read that document explicitly.'] },
  { id: 'controlled_ht3', title: 'How activated learning is used',
    body: ['Only hints are supplied: layout, title block, stamps, field mapping, material aliases, examples.',
      'It never auto-confirms a person and never overrides permissions, evidence,',
      'the material dictionary or the document profile registry. Model weights stay untouched.'] },
  { id: 'influence_ht4', title: 'Learning used for this reading',
    body: ['Each document shows which approved learning was used for its reading.',
      'Viewers see a plain summary of what it affected; admins additionally see the rule,',
      'the before → after value, where it applied and which rules were out of scope.',
      'Learning only produces candidates — it never confirms them.'] },
  { id: 'impact_ht4', title: 'Learning impact review (admins)',
    body: ['効果を確認 → 学習の適用状況 shows how each activated rule is actually being used.',
      'Per rule: whether it is used, how many documents, which effect, with a plain explanation.',
      'Rules that are never used are surfaced so an over-narrow scope can be revisited.',
      'Old documents are never rewritten automatically — only new reads and explicit re-reads.'] },
  { id: 'reread_ht4', title: 'Documents worth re-reading (admins)',
    body: ['効果を確認 → 読み直すと役立つ書類 lists documents the active learning would improve.',
      'Each row states why in plain Japanese (e.g. an OCR alias that now applies).',
      'Nothing is re-read automatically: an admin selects the documents, up to 20 per run.',
      'Confirmed and corrected values are never overwritten — new readings appear as candidates.',
      'The reading setup (model, prompts, feature routing) is not changed.'] },
  { id: 'ops_ht45', title: 'Daily operations (HT-4.5)',
    body: ['Employee master match: read names are matched against the employee master — exact, then approved alias, then partial. Suggestions only; nothing is confirmed or selected automatically.',
      'Bulk responsibility review: ドキュメント → 責任者の一括確認 clears unconfirmed drafter / designer / checker / approver fields in one screen, using the same confirm API.',
      'Re-read history: who re-read which documents and when, taken from the audit record.',
      'Real-document coverage: per drawing type, what is still missing plus the real documents you can add. Four steps: 実書類を取り込む → 読み取る → 期待値を入力する → 実書類で確認済み. A document read as another type is never registered, and a type your company never produces can be marked 対象外 with a recorded reason (still not activated, because there is no real document).',
      'Monthly report: saved automatically each month, with a 宿題 list linking to the next action. Export stays manual.'] },
  { id: 'validate', title: 'How validation works',
    body: ['Fixtures and negative controls are compared before and after.',
      'False person matches, department/person confusion and forbidden-field leakage block activation.'] },
  { id: 'activate', title: 'How activation works',
    body: ['Approve → Validate → Activate are separate actions.',
      'Historical reads are never rewritten; re-read documents explicitly if needed.'] },
  { id: 'rollback', title: 'How rollback works',
    body: ['Evaluate → Learning history → “Restore the previous learning content”.',
      'The previous active version becomes active again; confirmed values stay unchanged.'] },
  { id: 'stamps', title: 'Stamps and handwriting',
    body: ['Candidates come from position, shape, text and the nearby printed label.',
      'A stamp alone never confirms a person; department seals are never people.'] },
  { id: 'confidential', title: 'Confidential documents',
    body: ['Document permissions always apply; inaccessible documents cannot be used.',
      'Deleted sources deactivate the example; reports never expose confidential content.'] },
  { id: 'trouble', title: 'Troubleshooting',
    body: ['“Cannot activate”: validation found a regression — open the reasons.',
      '“Stale example”: the source changed; re-read the document first.',
      'No candidate: the stamp is faint or the cell is empty — leave it unreadable.'] },
  { id: 'glossary', title: 'Glossary',
    body: ['Training example / correction / learning candidate / approved learning / active learning content / evaluation / field position / stamp type / entity type.'] },
];

export default function LearningGuide() {
  const [lang, setLang] = useState('ja');
  const ja = lang === 'ja';
  const sections = ja ? SECTIONS_JA : SECTIONS_EN;
  const quick = ja ? QUICK_JA : QUICK_EN;
  return (
    <div className="space-y-4 p-4 sm:p-6" data-testid="learning-guide-page">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <a href="/settings/doc-learning"
            className="inline-flex min-h-[32px] items-center text-[12px] text-teal-700 hover:underline"
            data-testid="guide-back">
            <ArrowLeft size={13} className="mr-1" />
            {ja ? '書類読み取り学習に戻る' : 'Back to Document Intelligence Learning'}
          </a>
          <h1 className="pt-1 text-2xl font-semibold text-zinc-900">
            {ja ? '書類読み取り学習の使い方' : 'Using Document Intelligence Learning'}
          </h1>
        </div>
        <div className="flex gap-1.5" role="group" aria-label={ja ? '表示言語' : 'Language'}>
          {[['ja', '日本語'], ['en', 'English']].map(([k, l]) => (
            <button key={k} type="button" onClick={() => setLang(k)}
              className={`min-h-[32px] rounded-full border px-3 text-[12px] ${
                lang === k ? 'border-teal-700 bg-teal-700 text-white'
                  : 'border-zinc-200 bg-white text-zinc-700 hover:bg-zinc-50'}`}
              data-testid={`guide-lang-${k}`}>{l}</button>
          ))}
        </div>
      </div>

      <Panel title={ja ? '5つの手順' : 'Five steps'} testId="guide-quick">
        <ol className="space-y-1.5">
          {quick.map((s, i) => (
            <li key={s} className="flex items-start gap-2 text-[12.5px] text-zinc-800"
              data-testid={`guide-quick-${i + 1}`}>
              <span className="mt-0.5 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-teal-700 text-[11px] text-white">
                {i + 1}
              </span>
              {s}
            </li>
          ))}
        </ol>
        <Button className="mt-3 h-10 bg-teal-700 text-[12.5px] hover:bg-teal-800"
          onClick={() => { window.location.href = '/settings/doc-learning'; }}
          data-testid="guide-primary">
          {ja ? '学習用の書類を追加' : 'Add a training document'}
        </Button>
      </Panel>

      {sections.map((s) => (
        <Panel key={s.id} title={s.title} testId={`guide-section-${s.id}`}>
          <ul className="space-y-1">
            {s.body.map((b) => (
              <li key={b} className="text-[12.5px] leading-relaxed text-zinc-700">・{b}</li>
            ))}
          </ul>
        </Panel>
      ))}
    </div>
  );
}
